import app from 'flarum/forum/app';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import Icon from 'flarum/common/components/Icon';
import { extend } from 'flarum/common/extend';
import isVnodeWithClass from './utils/isVnodeWithClass';

/**
 * The search halos: a focus glow behind the SearchModal input and an
 * always-on ring round the header search button. Only when semantic search
 * is enabled; `data-glowingblue-ai` gates the related LESS.
 */
export function bootAiSparkle() {
  if (!app.forum.attribute('glowingblueSearchSemanticEnabled')) {
    return;
  }
  document.body.setAttribute('data-glowingblue-ai', 'on');

  // SearchModal is a lazy chunk, so it is extended by module path.
  extend('flarum/common/components/SearchModal', 'content', function (vnode) {
    const children = vnode.children;
    if (!Array.isArray(children)) return;
    const form = children.find(child => isVnodeWithClass(child, 'SearchModal-form'));
    if (form) addHalo(form);
    children.push(renderPoweredBy());
  });

  // GlobalSearch is in the boot bundle; a module path would never resolve.
  // Its view() is a <div.Search> holding the <button.Search-input> that opens
  // the modal. The ring renders inside the button, but CSS sizes it to the
  // whole `.Search` control (see forum.less).
  extend(GlobalSearch.prototype, 'view', function (vnode) {
    if (!vnode || !isVnodeWithClass(vnode, 'Search')) return;
    const children = vnode.children;
    if (!Array.isArray(children)) return;
    const button = children.find(child => isVnodeWithClass(child, 'Search-input'));
    if (button) addButtonHalo(button);
  });
}

/**
 * Tag the form wrapper and prepend the halo overlay; CSS shows it while the
 * input has focus.
 */
function addHalo(vnode) {
  var _attrs, _ref;
  const attrs = (_attrs = vnode.attrs) != null ? _attrs : {};
  const existing = (_ref = attrs.className) != null ? _ref : '';
  if (existing.split(' ').includes('GlowingBlueSearch-haloWrap')) return;
  attrs.className = [existing, 'GlowingBlueSearch-haloWrap'].filter(Boolean).join(' ');
  vnode.attrs = attrs;
  const children = vnode.children;
  const childArr = Array.isArray(children) ? children : [children];
  vnode.children = [m('span', {
    className: 'GlowingBlueSearch-halo',
    'aria-hidden': 'true'
  }, m('span', {
    className: 'GlowingBlueSearch-halo-ring'
  })), ...childArr];
}

/**
 * Prepend the ring halo to the header search button. The halo is
 * absolutely positioned, so it stays out of the button's flex layout.
 */
function addButtonHalo(vnode) {
  const children = vnode.children;
  const childArr = Array.isArray(children) ? children : [children];
  if (childArr.some(child => isVnodeWithClass(child, 'GlowingBlueSearch-buttonHalo'))) return;
  vnode.children = [m('span', {
    className: 'GlowingBlueSearch-buttonHalo',
    'aria-hidden': 'true'
  }, m('span', {
    className: 'GlowingBlueSearch-buttonHalo-ring'
  })), ...childArr];
}
function renderPoweredBy() {
  return m('div', {
    className: 'GlowingBlueSearch-poweredBy'
  }, [m(Icon, {
    name: 'fas fa-wand-magic-sparkles'
  }), m('span', app.translator.trans('glowingblue-search.forum.powered_by')), m('span', {
    className: 'GlowingBlueSearch-poweredBy-product'
  }, app.translator.trans('glowingblue-search.forum.powered_by_product'))]);
}